import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

import { routes } from './app.routes';

const AppPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#E9EEF6',
      100: '#D1DDF0',
      200: '#A2BADD',
      300: '#7696C6',
      400: '#4F76AF',
      500: '#355B96',
      600: '#274472',
      700: '#1F3760',
      800: '#182948',
      900: '#111C33',
      950: '#0A111F'
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withFetch()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: AppPreset,
        options: {
          darkModeSelector: '.app-dark',
          cssLayer: {
            name: 'primeng',
            order: 'bootstrap, primeng'
          }
        }
      }
    })
  ]
};
